/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum SellerUserType {
    ARTIST = 'Artist',
    AGENT = 'Agent',
    MANAGER = 'Manager',
    OTHER = 'Other',
}